"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageUpload = void 0;

var tslib_1 = require("tslib");

var ui_button_1 = require("@hopin-team/ui-button");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_icon_1 = require("@hopin-team/ui-icon");

var ui_text_1 = require("@hopin-team/ui-text");

var ui_visually_hidden_1 = require("@hopin-team/ui-visually-hidden");

var react_1 = tslib_1.__importStar(require("react"));

var react_dropzone_1 = require("react-dropzone");

var config_1 = require("./config");

var image_upload_error_1 = require("./partials/image-upload-error");

var root_1 = require("./styled/root");

var defaultRenderPreview = function defaultRenderPreview(images) {
  return react_1.default.createElement(root_1.Preview, {
    src: images[0].preview,
    alt: images[0].name,
    "data-testid": "default-preview-container"
  });
};

var ImageUpload = function ImageUpload(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      messagesFromProps = _a.messages,
      optionsFromProps = _a.options,
      onImagesChange = _a.onImagesChange,
      _b = _a.inputAriaLabel,
      inputAriaLabel = _b === void 0 ? 'Image Upload' : _b,
      _c = _a.width,
      width = _c === void 0 ? 430 : _c,
      _d = _a.height,
      height = _d === void 0 ? 430 / (16 / 9) : _d,
      _e = _a.actionButtons,
      actionButtonsFromProps = _e === void 0 ? [] : _e,
      _f = _a.renderPreview,
      renderPreview = _f === void 0 ? defaultRenderPreview : _f;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'ImageUpload',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;

  var _g = tslib_1.__read((0, react_1.useState)(false), 2),
      isDragOverActive = _g[0],
      setDragOver = _g[1];

  var _h = tslib_1.__read((0, react_1.useState)(), 2),
      images = _h[0],
      setImages = _h[1];

  var m = (0, react_1.useMemo)(function () {
    return tslib_1.__assign(tslib_1.__assign({}, config_1.DEFAULT_MESSAGES), messagesFromProps);
  }, [messagesFromProps]);
  var options = (0, react_1.useMemo)(function () {
    return tslib_1.__assign(tslib_1.__assign({}, config_1.DEFAULT_OPTIONS), optionsFromProps);
  }, [optionsFromProps]);
  var actionButtons = (0, react_1.useMemo)(function () {
    return tslib_1.__spreadArray([{
      onClick: function onClick() {
        setImages([]);
        onImagesChange([]);
      },
      title: 'delete image',
      icon: 'delete'
    }], tslib_1.__read(actionButtonsFromProps), false);
  }, [actionButtonsFromProps, onImagesChange]);

  var _j = (0, react_dropzone_1.useDropzone)(tslib_1.__assign(tslib_1.__assign({}, options), {
    onDrop: function onDrop(acceptedImages) {
      var images = acceptedImages.map(function (file) {
        return Object.assign(file, {
          preview: URL.createObjectURL(file)
        });
      });
      setImages(images);
      onImagesChange(images);
      setDragOver(false);
    },
    onDragEnter: function onDragEnter() {
      return setDragOver(true);
    },
    onDragLeave: function onDragLeave() {
      return setDragOver(false);
    }
  })),
      getRootProps = _j.getRootProps,
      getInputProps = _j.getInputProps,
      fileRejections = _j.fileRejections;

  var isError = fileRejections && fileRejections.length > 0;
  var isPreview = images && images.length > 0;
  return react_1.default.createElement(root_1.Root, {
    className: rootClasses
  }, react_1.default.createElement(ui_visually_hidden_1.VisuallyHidden, null, react_1.default.createElement("input", tslib_1.__assign({}, getInputProps(), {
    "data-testid": "file-upload",
    role: "button",
    "aria-label": inputAriaLabel,
    style: {
      display: 'block'
    }
  }))), isPreview ? react_1.default.createElement(root_1.PreviewContainer, {
    width: width,
    height: height
  }, renderPreview(images), react_1.default.createElement(root_1.ActionsContainer, null, actionButtons.map(function (buttonProps) {
    return react_1.default.createElement(root_1.ActionButton, tslib_1.__assign({
      key: buttonProps.title,
      size: "small",
      pattern: "inverse",
      ml: 2
    }, buttonProps));
  }))) : react_1.default.createElement(root_1.Container, {
    "data-testid": "file-upload-container",
    isDragOver: isDragOverActive,
    hoverEnabled: !isPreview,
    width: width,
    height: height
  }, react_1.default.createElement(root_1.InnerContainer, tslib_1.__assign({}, getRootProps({
    className: 'dropzone'
  })), react_1.default.createElement(ui_icon_1.Icon, {
    name: "publish",
    color: isDragOverActive ? 'theme-primary' : 'grey-600',
    scale: 3,
    mb: 2
  }), !isDragOverActive && react_1.default.createElement(ui_button_1.Button, {
    pattern: "secondary",
    isInline: true,
    isOutlined: true,
    size: "medium",
    mb: 2
  }, m.uploadImage), react_1.default.createElement(ui_text_1.Text, {
    pattern: "body",
    color: isDragOverActive ? 'theme-primary' : 'grey-600'
  }, isDragOverActive ? m.dropFile : m.orDropFile))), isError ? react_1.default.createElement(image_upload_error_1.ImageUploadError, {
    messages: m,
    fileRejections: fileRejections
  }) : react_1.default.createElement(ui_text_1.Text, {
    pattern: "caption",
    color: "grey-600"
  }, m.fileHints, " ", m.maximumUploadSize, ":", ' ', (options.maxSize || config_1.DEFAULT_OPTIONS.maxSize) / config_1.ONE_MEGA_BYTE, "MB"));
};

var ImageUploadWithSpace = (0, ui_helper_with_space_1.withSpace)(ImageUpload);
exports.ImageUpload = ImageUploadWithSpace;